import { render, staticRenderFns } from "./FoShanPensionDevelopmentProcess.vue?vue&type=template&id=3c8c8cca&"
import script from "./FoShanPensionDevelopmentProcess.vue?vue&type=script&lang=js&"
export * from "./FoShanPensionDevelopmentProcess.vue?vue&type=script&lang=js&"
import style0 from "./FoShanPensionDevelopmentProcess.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports